// src/lib/redflags.ts
import type { Answer } from './questions'

export interface RedFlagReason {
  code: string
  questionId: string
  label: string
  urgency: string
}

export interface RedFlagResult {
  hasRedFlag: boolean
  reasons: RedFlagReason[]
}

const RED_FLAG_TRIGGERS: {
  questionId: string
  answerKey: string
  code: string
  label: string
  urgency: string
}[] = [
  {
    questionId: 'Q5',
    answerKey: 'absent-6m-plus',
    code: 'absent-periods-6m',
    label: 'Your period has been absent for more than 6 months',
    urgency: 'Secondary amenorrhoea >6 months — rule out hyperprolactinemia, severe PCOS, hypothalamic dysfunction',
  },
  {
    questionId: 'Q11',
    answerKey: 'regularly',
    code: 'nipple-discharge-regular',
    label: 'Regular nipple discharge outside pregnancy/breastfeeding',
    urgency: 'Galactorrhoea — probable hyperprolactinemia; fasting morning serum prolactin priority',
  },
  {
    questionId: 'Q4',
    answerKey: 'debilitating',
    code: 'debilitating-pain',
    label: 'Debilitating period pain affecting daily function',
    urgency: 'Severe dysmenorrhoea — rule out endometriosis, adenomyosis',
  },
  {
    questionId: 'Q24',
    answerKey: 'ttc-6m-plus',
    code: 'ttc-prolonged',
    label: 'Trying to conceive for more than 6 months without success',
    urgency: 'Subfertility >6 months — dual flow activation, elevated investigation urgency',
  },
]

export function detectRedFlags(answers: Answer[]): RedFlagResult {
  const triggered: RedFlagReason[] = []

  for (const trigger of RED_FLAG_TRIGGERS) {
    const answer = answers.find(a => a.questionId === trigger.questionId)
    if (answer && answer.answerKey === trigger.answerKey) {
      triggered.push({
        code: trigger.code,
        questionId: trigger.questionId,
        label: trigger.label,
        urgency: trigger.urgency,
      })
    }
  }

  return {
    hasRedFlag: triggered.length > 0,
    reasons: triggered,
  }
}
